<template>
  <div class='table-column'>
    <div :style='cssVars' class='table-column__title'>
      {{ category.title }}
    </div>
    <div
      class="table-column__values"
      :style='cssVars'
      v-for='(item, index) in items'
      :key='index'
    >
      <slot name="column-cell" :category="category" :item="item">
        <TableDefaultCell :category="category" :item="item" />
      </slot>
    </div>
  </div>
</template>

<script>
import TableDefaultCell from '@/components/TableByColumn/TableDefaultCell.vue';

export default {
  name: 'TableRow',
  components: { TableDefaultCell },
  props: {
    category: {
      required: true,
      type: Object,
    },
    items: {
      required: true,
      type: Array,
    },
  },
  computed: {
    cssVars() {
      return {
        '--width': `calc(100% / ${this.items.length})`,
      };
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';
.table-column {
  display: flex;
  flex-direction: row;
  height: rem(60);
  align-items: center;
  &__title {
    width: calc(var(--width) + #{$space-12});
    min-width: rem(130);
    color: var(--text-primary);
    font-family: $font-family-regular;
    font-size: rem(12);
    letter-spacing: 0;
    margin-left: rem(19);
  }
  &__values {
    width: var(--width);
    color: var(--text-primary);
    font-family: $font-family-regular;
    font-size: rem(14);
    font-weight: bold;
    letter-spacing: 0;
  }
}
</style>
